import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowForward = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 20,
	viewBox: "3 3 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0007 3.33398L8.82565 4.50898L13.4757 9.16732H3.33398V10.834H13.4757L8.82565 15.4923L10.0007 16.6673L16.6673 10.0007L10.0007 3.33398Z",
		fill: "#2E4B93"
	})
});
export default SvgArrowForward;
